<script>
/* COMPOSANTS */
import AkLoader from '@components/general/AkLoader.vue';
import AkPictureAccommodation from '@components/v2/general/AkPictureAccommodation.vue';
import PrestationBadge from '@components/general/PrestationBadge.vue';

/* SERVICES */
import housekeeperAccommodationService from '@services/housekeeperAccommodationService';

export default {
  components: {AkLoader, AkPictureAccommodation, PrestationBadge},
  props: {
    modelValue: {
      required: true,
    },
  },
  emits: ['error'],
  data() {
    return {
      housekeeperAccommodations: [],
    };
  },
  mounted() {
    this.refresh();
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
    },
  },
  methods: {
    refresh() {
      this.$refs.loader.load();

      housekeeperAccommodationService
        .housekeeperAccommodationsForHousekeeper(this.currentValue.id)
        .then((data) => {
          this.housekeeperAccommodations = data;
        })
        .catch((e) => {
          this.$emit('error', e);
        })
        .finally(() => {
          this.$refs.loader.hide();
        });
    },

    isReceptionTypePhysical(ha) {
      return ha.receptionTypeCheckin === 'PHYSICAL' || ha.receptionTypeCheckout === 'PHYSICAL';
    },
  },
};
</script>

<template>
  <AkLoader ref="loader" :message="$t('currently_loading')">
    <template #content>
      <div class="flex flex-col gap-4">
        <span class="title-border secondary">{{ $t('accommodation.list') }}</span>
        <div
          v-if="housekeeperAccommodations?.length > 0"
          class="grid 2xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 md:gap-4 gap-2">
          <div v-for="ha in housekeeperAccommodations" :key="ha.id">
            <AkPictureAccommodation
              :id="ha.accommodationId"
              :md5="ha.accommodationPicture"
              :name="ha.accommodationName"
              :physical="isReceptionTypePhysical(ha)"
              cover
              :height="134"
              radius="rounded-t-lg" />
            <div class="flex flex-col gap-4 w-full mb-4 p-6 bg-white rounded-lg">
              <span class="font-inter font-semibold text-grey-900 text-base">Prestations</span>
              <template v-if="ha?.prestationTypes?.length > 0">
                <div v-for="mission in ha.prestationTypes" :key="mission" class="flex justify-start items-center gap-4">
                  <PrestationBadge :type="mission" />
                </div>
              </template>
              <span v-else>Aucune prestation à afficher</span>
            </div>
          </div>
        </div>
        <span v-else>Aucun logement à afficher</span>
      </div>
    </template>
  </AkLoader>
</template>
